import type { Event } from 'models';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { ChannelsDetailCard } from 'features/channels/components';

type P = {
  event: Event;
};

const EventChannel = ({ event: { channel } }: P) =>
  channel ? (
    <ChannelsDetailCard
      channelAppearance={{
        featured: channel.featuredInChannels,
        visible: channel.showInChannel,
      }}
      channelTags={channel.tags?.map((tag) => ({ id: tag, name: tag }))}
      organizationId={channel.organizationHashId}
    />
  ) : null;

export default EventChannel;
